import React from "react";
import Child from "./Child";
import classNames from "../../classNames";
// import classNames from "../classNames";

const defaultIcon = "bi bi-journal-text";
const defaultProps = {
  onClick: () => {},
};

function Item({ menu, onClick }) {
  const { name, icon, label, disabled } = menu;
  const route = menu.route || "/" + name;
  if (Array.isArray(route)) {
    return <Child menu={menu} onClick={onClick} />;
  }
  return (
    <li className="nav-item" key={route} style={{ listStyle: "none" }}>
      <a
        onClick={(e) => onClick(e, menu)}
        href={route}
        className={classNames(
          "nav-link text-truncate text-white",
          disabled ? "disabled" : ""
        )}
        to={route}
        style={{
          borderRadius: "8px",
          marginBottom: "4px",
          padding: "8px 12px",
          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          display: "flex",
          alignItems: "center",
          textDecoration: "none",
          border: "1px solid transparent",
          fontSize: "0.85rem",
          fontWeight: "500",
          letterSpacing: "0.1px",
          backgroundColor: "transparent",
        }}
        onMouseEnter={(e) => {
          if (!disabled) {
            e.currentTarget.style.backgroundColor = "rgba(131, 193, 74, 0.12)";
            e.currentTarget.style.borderColor = "rgba(131, 193, 74, 0.25)";
            e.currentTarget.style.transform = "translateX(4px)";
            e.currentTarget.style.boxShadow = "0 2px 8px rgba(131, 193, 74, 0.15)";
          }
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "transparent";
          e.currentTarget.style.borderColor = "transparent";
          e.currentTarget.style.transform = "translateX(0)";
          e.currentTarget.style.boxShadow = "none";
        }}
      >
        <div 
          style={{ 
            width: "28px",
            height: "28px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "6px",
            backgroundColor: "rgba(255,255,255,0.05)",
            transition: "all 0.3s ease",
            flexShrink: 0,
          }}
        >
          <i className={icon || defaultIcon} style={{ fontSize: "0.9rem", color: "#a8d97f" }}></i>
        </div>
        <span className="ms-2" style={{ flex: 1, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{label || name}</span>
      </a>
    </li>
  );
}

Item.defaultProps = defaultProps;
export default Item;
